export default "__VITE_ASSET__bx88Vfuz__"